<template>
  <div>
    <!-- 
			New modal dialog. mobile's view
		-->
    <a-modal v-if="isMobile()" v-model="dialogVisible" :title="title" :maskClosable="false" forceRender @ok="onSubmit">
      <a-row type="flex" justify="space-between" align="top">
        <a-col :span="24">
          <div>
            Name *
            <a-input v-model="name" placeholder="" />
            <div style="margin: 10px 0" />
            Floor *
            <a-input v-model="floor" placeholder="" />
            <div style="margin: 10px 0" />
            Type *
            <a-input v-model="type" placeholder="" />
            <div style="margin: 10px 0" />
            <!-- IP Address
            <a-input v-model="ip" placeholder="" />
            <div style="margin: 10px 0" /> -->
            Card
            <a-input v-model="rfid" placeholder="" />
            <div style="margin: 10px 0" />
            Capacity *
            <a-input v-model="capacity" placeholder="" />
            <div style="margin: 10px 0" />
            Allow for booking *
            <a-select default-value="Yes" v-model="allowBooking" style="width: 100%">
              <a-select-option value="Yes"> Yes </a-select-option>
              <a-select-option value="No"> No </a-select-option>
            </a-select>
            Allow for future booking *
            <a-select default-value="Yes" v-model="allowFutureBooking" style="width: 100%">
              <a-select-option value="Yes"> Yes </a-select-option>
              <a-select-option value="No"> No </a-select-option>
            </a-select>
            <!-- <div style="margin: 10px 0" />
            Require approval for booking *
            <a-select default-value="Yes" v-model="requireApprovalBooking" style="width: 100%">
              <a-select-option value="Yes"> Yes </a-select-option>
              <a-select-option value="No"> No </a-select-option>
            </a-select> -->
            <div style="margin: 10px 0" />
            Status *
            <a-select default-value="Enable" v-model="status" style="width: 100%">
              <a-select-option value="Enable"> Enable </a-select-option>
              <a-select-option value="Disable"> Disable </a-select-option>
            </a-select>
            <div style="margin: 10px 0" />
            Remark
            <a-textarea v-model="remark" placeholder="" :rows="5" />
            <div style="margin: 10px 0" />
          </div>
        </a-col>
      </a-row>
    </a-modal>

    <!-- 
			New modal dialog. desktop's view
		-->
    <a-modal v-else v-model="dialogVisible" :title="title" :maskClosable="false" @ok="onSubmit" forceRender width="60%">
      <div style="overflow-y: scroll; height: 400px; padding-right: 10px">
        <a-row type="flex" justify="space-between" align="top">
          <a-col :span="24">
            <div>
              Name *
              <a-input v-model="name" placeholder="" />
              <div style="margin: 10px 0" />
              Building *
              <a-input v-model="building" placeholder="" />
              <div style="margin: 10px 0" />
              Floor *
              <a-input v-model="floor" placeholder="" />
              <div style="margin: 10px 0" />
              Type *
              <a-input v-model="type" placeholder="" />
              <div style="margin: 10px 0" />
              IP Address
              <a-input v-model="ip" placeholder="" />
              <div style="margin: 10px 0" />
              MCU
              <a-input v-model="mcu" placeholder="" />
              <div style="margin: 10px 0" />
              <!-- Card
              <a-input v-model="rfid" placeholder="" />
              <div style="margin: 10px 0" /> -->
              Capacity *
              <a-input v-model="capacity" placeholder="" />
              <div style="margin: 10px 0" />
              Allow for booking *
              <a-select default-value="Yes" v-model="allowBooking" style="width: 100%">
                <a-select-option value="Yes"> Yes </a-select-option>
                <a-select-option value="No"> No </a-select-option>
              </a-select>
              <div style="margin: 10px 0" />
              Allow for future booking *
              <a-select default-value="Yes" v-model="allowFutureBooking" style="width: 100%">
                <a-select-option value="Yes"> Yes </a-select-option>
                <a-select-option value="No"> No </a-select-option>
              </a-select>
              <!-- <div style="margin: 10px 0" />
              Require approval for booking *
              <a-select default-value="Yes" v-model="requireApprovalBooking" style="width: 100%">
                <a-select-option value="Yes"> Yes </a-select-option>
                <a-select-option value="No"> No </a-select-option>
              </a-select> -->
              <div style="margin: 10px 0" />
              Status *
              <a-select default-value="Enable" v-model="status" style="width: 100%">
                <a-select-option value="Enable"> Enable </a-select-option>
                <a-select-option value="Disable"> Disable </a-select-option>
              </a-select>
              <div style="margin: 10px 0" />
              Remark
              <a-textarea v-model="remark" placeholder="" :rows="5" />
              <div style="margin: 10px 0" />
            </div>
          </a-col>
        </a-row>
      </div>
    </a-modal>

    <!-- Search modal dialog -->
    <searchRoomAdvance ref="search" :search="onSearchSubmit" />

    <!-- 
			Data, desktop's view
		-->
    <div>
      <a-card :bordered="false" class="header-solid h-full">
        <!-- Title -->
        <template #title>
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="12">
              <h5 class="font-semibold m-0">Rooms</h5>
            </a-col>
            <a-col :span="12" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              ">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Download excel file</span>
                </template>
                <a-button type="default" shape="circle" icon="file-excel" @click="onClickDownloadExcel" />
              </a-tooltip>
              <a-divider type="vertical" />
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Clear</span>
                </template>
                <a-button type="default" shape="circle" icon="reload" @click="onClear" /> </a-tooltip>&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Search</span>
                </template>
                <a-button type="default" shape="circle" icon="search" @click="onSearch" /> </a-tooltip>&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>New</span>
                </template>
                <a-button type="primary" shape="circle" icon="plus" @click="onNew" /></a-tooltip>
            </a-col>
          </a-row>
        </template>
        <!-- Body -->
        <a-table :columns="columns" :data-source="data" rowKey="_id">
          <template slot="open" slot-scope="open">
            <a-tag v-if="open === true" color="green">Yes</a-tag>
            <a-tag v-if="open === false" color="red">No</a-tag>
          </template>
          <template slot="allowBooking" slot-scope="allowBooking">
            <a-tag v-if="allowBooking === 'Yes'" color="green">{{
      allowBooking
    }}</a-tag>
            <a-tag v-if="allowBooking === 'No' || allowBooking === undefined" color="red">No</a-tag>
          </template>
          <template slot="allowFutureBooking" slot-scope="allowFutureBooking">
            <a-tag v-if="allowFutureBooking === 'Yes'" color="green">{{
      allowFutureBooking
    }}</a-tag>
            <a-tag v-if="allowFutureBooking === 'No' || allowFutureBooking === undefined" color="red">No</a-tag>
          </template>
          <!-- <template slot="requireApprovalBooking" slot-scope="requireApprovalBooking">
            <a-tag v-if="requireApprovalBooking === 'Yes'" color="green">{{
      requireApprovalBooking
    }}</a-tag>
            <a-tag v-if="requireApprovalBooking === 'No' || requireApprovalBooking === undefined" color="red">No</a-tag>
          </template>
          <template slot="status" slot-scope="status">
            <a-tag v-if="status === 'Enable'" color="green">{{ status }}</a-tag>
            <a-tag v-if="status === 'Disable'" color="red">{{ status }}</a-tag>
          </template> -->
          <!--
					<template slot="remark" slot-scope="remark">
						<span style="white-space: pre-line">{{remark}}</span>
					</template>
					-->
          <template slot="action" slot-scope="row">
            <div style="float: right">
              <a-dropdown-button>
                Options
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="onToggleOnOff(row)">
                    <a-icon type="api" /> Always on/off</a-menu-item>
                  <a-menu-item key="2" @click="onOpenInfo(row)">
                    <a-icon type="info" /> Infomation</a-menu-item>
                  <a-menu-item key="3" @click="onEdit(row)">
                    <a-icon type="edit" /> Edit</a-menu-item>
                  <a-menu-item key="4" @click="onDelete(row)">
                    <a-icon type="delete" />
                    <span style="color: #ff0000">Delete</span></a-menu-item>
                </a-menu>
              </a-dropdown-button>
            </div>
          </template>
        </a-table>
      </a-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import searchRoomAdvance from "../../components/Search/SearchRoomAdvance";
import tools from "../../utils/tools";
import notify from "../../utils/notify";

export default {
  //
  //
  //
  components: {
    searchRoomAdvance
  },
  //
  //
  //
  data() {
    return {
      data: [],
      dataSearch: {},
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Type",
          dataIndex: "type",
          scopedSlots: { customRender: "type" }
        },
        {
          title: "Building",
          dataIndex: "building",
          scopedSlots: { customRender: "building" }
        },
        {
          title: "Floor",
          dataIndex: "floor",
          scopedSlots: { customRender: "floor" }
        },
        {
          title: "MCU",
          dataIndex: "mcu",
          scopedSlots: { customRender: "mcu" }
        },
        {
          title: "IP",
          dataIndex: "ip",
          scopedSlots: { customRender: "ip" }
        },
        // {
        //   title: "Card",
        //   dataIndex: "rfid",
        //   scopedSlots: { customRender: "rfid" }
        // },
        {
          title: "Capacity",
          dataIndex: "capacity",
          scopedSlots: { customRender: "capacity" }
        },
        {
          title: "Always On",
          dataIndex: "open",
          scopedSlots: { customRender: "open" }
        },
        {
          title: "Allow Booking",
          dataIndex: "allowBooking",
          scopedSlots: { customRender: "allowBooking" }
        },
        {
          title: "Future Booking",
          dataIndex: "allowFutureBooking",
          scopedSlots: { customRender: "allowFutureBooking" }
        },
        // {
        //   title: "Approval Booking",
        //   dataIndex: "requireApprovalBooking",
        //   scopedSlots: { customRender: "requireApprovalBooking" }
        // },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        // {
        // 	title: 'Remark',
        // 	dataIndex: 'remark',
        // 	scopedSlots: { customRender: 'remark' },
        // },
        {
          title: "",
          dataIndex: "",
          scopedSlots: { customRender: "action" }
        }
      ],
      //
      mode: "new",
      // Modal dialog
      title: "New",
      dialogVisible: false,
      // Data
      id: "",
      name: "",
      building: "",
      floor: "",
      type: "",
      mcu: "",
      ip: "",
      rfid: "",
      capacity: 1,
      allowBooking: "Yes",
      allowFutureBooking: "Yes",
      requireApprovalBooking: "No",
      status: "Enable",
      remark: ""
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  created() { },
  //
  //
  //
  beforeMounted() { },
  //
  //
  //
  mounted() {
    if (!tools.isLogin()) return;
    this.requestData();
  },
  //
  //
  //
  beforeUpdated() { },
  //
  //
  //
  updated() { },
  //
  //
  //
  beforeDestroy() { },
  //
  //
  //
  destroyed() { },
  //
  //
  //
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    // Request data.
    //
    requestData() {
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/rooms", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onOpenInfo(item) {
      this.$router.push("/roominfo/" + item._id);
    },
    //
    // New data.
    //
    onNew() {
      this.dialogVisible = true;
      this.mode = "new";
      this.title = "New";
      //
      this.id = "";
      this.name = "";
      this.building = "";
      this.floor = "";
      this.type = "";
      this.mcu = "";
      this.ip = "";
      this.rfid = "";
      this.capacity = 1;
      this.allowBooking = "Yes";
      this.status = "Enable";
      this.remark = "";
    },
    //
    // Edit data.
    //
    onEdit(item) {
      this.dialogVisible = true;
      this.mode = "edit";
      this.title = "Edit";
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/rooms/get/" + item._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          const data = response.data.data;
          this.id = data._id;
          this.name = data.name;
          this.building = data.building;
          this.floor = data.floor;
          this.type = data.type;
          this.mcu = data.mcu;
          this.ip = data.ip;
          this.rfid = data.rfid;
          this.capacity = data.capacity;
          this.allowBooking = data.allowBooking;
          this.allowFutureBooking = data.allowFutureBooking;
          this.requireApprovalBooking = data.requireApprovalBooking;
          this.status = data.status;
          this.remark = data.remark;
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onSubmit() {
      this.dialogVisible = false;

      // Check require fields
      if (
        this.name === "" ||
        this.building === "" ||
        this.floor === "" ||
        this.type === "" ||
        this.capacity === ""
      ) {
        notify.errorNotify(
          this.$notification,
          <a-icon type="close-circle" style="color: #FF0000" />,
          "ใส่ข้อมูลไม่ครบ"
        );
        return;
      }

      //
      if (this.mode === "new") {
        axios
          .post(
            process.env.VUE_APP_INVENTORY_API + "/rooms",
            {
              name: this.name,
              building: this.building,
              floor: this.floor,
              type: this.type,
              mcu: this.mcu,
              ip: this.ip,
              rfid: this.rfid,
              capacity: this.capacity,
              allowBooking: this.allowBooking,
              allowFutureBooking: this.allowFutureBooking,
              requireApprovalBooking: this.requireApprovalBooking,
              status: this.status,
              remark: this.remark
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("accessToken")
              }
            }
          )
          .then(response => {
            notify.successNotify(
              this.$notification,
              <a-icon type="check-circle" style="color: #00FF00" />,
              "บันทึกข้อมูลเรียบร้อย"
            );
            this.requestData();
          })
          .catch(error => {
            notify.errorNotify(
              this.$notification,
              <a-icon type="close-circle" style="color: #FF0000" />,
              error
            );
            return;
          });
      } else {
        axios
          .put(
            process.env.VUE_APP_INVENTORY_API + "/rooms/" + this.id,
            {
              name: this.name,
              building: this.building,
              floor: this.floor,
              type: this.type,
              mcu: this.mcu,
              ip: this.ip,
              rfid: this.rfid,
              capacity: this.capacity,
              allowBooking: this.allowBooking,
              allowFutureBooking: this.allowFutureBooking,
              requireApprovalBooking: this.requireApprovalBooking,
              status: this.status,
              remark: this.remark
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("accessToken")
              }
            }
          )
          .then(response => {
            notify.successNotify(
              this.$notification,
              <a-icon type="check-circle" style="color: #00FF00" />,
              "บันทึกข้อมูลเรียบร้อย"
            );

            this.onSearchSubmit(this.dataSearch);
          })
          .catch(error => {
            console.error(error);
            notify.errorNotify(
              this.$notification,
              <a-icon type="close-circle" style="color: #FF0000" />,
              error
            );
            return;
          });
      }
    },
    //
    // Delete data.
    //
    onDelete(item) {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่? ",
        onOk() {
          self.delete(item);
        },
        onCancel() { }
      });
    },
    //
    // Delete data.
    //
    delete(item) {
      axios
        .delete(process.env.VUE_APP_INVENTORY_API + "/rooms/" + item._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "ลบข้อมูลเรียบร้อย"
          );
          this.requestData();
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    onClear() {
      this.$refs.search.clearFilter();
      this.requestData();
    },
    //
    // Search data.
    //
    onSearch() {
      this.$refs.search.show();
    },
    //
    //
    //
    onSearchSubmit(data) {
      this.dataSearch = data;

      const params = "name=" +
        data.name +
        "&" +
        "building=" +
        data.building +
        "&" +
        "floor=" +
        data.floor +
        "&" +
        "type=" +
        data.type +
        "&" +
        "capacity=" +
        data.capacity +
        "&" +
        "remark=" +
        data.remark +
        "&" +
        "allowBooking=" +
        data.allowBooking +
        "&" +
        "status=" +
        data.status;

      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/rooms/search?" + params, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          console.log(error);
          return;
        });
    },
    //
    //
    //
    onToggleOnOff(item) {
      let endpoint = "";
      if (item.open === false) {
        endpoint =
          process.env.VUE_APP_INVENTORY_API + "/rooms/open/" + item._id;
      } else {
        endpoint =
          process.env.VUE_APP_INVENTORY_API + "/rooms/close/" + item._id;
      }
      axios
        .put(
          endpoint,
          {},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "เปลี่ยนสถานะเรียบร้อย"
          );
          this.requestData();
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    onClickDownloadExcel() {
      let csv =
        "Name,Type,Floor,MCU,IP,Capacity,Always On,Allow Booking,Status\n";
      this.data.forEach(row => {
        csv += row.name + ",";
        csv += row.type + ",";
        csv += row.building + ",";
        csv += row.floor + ",";
        csv += row.mcu + ",";
        csv += row.ip + ",";
        // csv += row.rfid + ",";
        csv += row.capacity + ",";
        csv += row.open + ",";
        csv += row.allowBooking + ",";
        csv += row.status + ",";
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "rooms.csv";
      anchor.click();
    }
  }
};
</script>

<style lang="scss">
table>tbody>tr {
  vertical-align: top;
}
</style>
